import React from "react";
import Slider from "react-slick";
import "./Announcements.css";
import announcements_data from "../../data/announcements";

const Announcements = () => {
    const announcements = announcements_data;

    const settings = {
        dots: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: false,
        arrows: false,
        pauseOnHover: true
    };

    return (
        <div className="announcements-container">
            <h2 className="announcements-heading">📢 Announcements</h2>
            {announcements && announcements.length > 0 ? (
                <div className="announcements-slider">
                    <Slider {...settings}>
                        {announcements.map((data, index) => (
                            <div key={index} className="announcement-slide">
                                <a href={data.url} className="announcement-link" target="_blank" rel="noopener noreferrer">
                                    {data.name}
                                </a>
                            </div>
                        ))}
                    </Slider>
                </div>
            ) : (
                <p className="no-announcements">📭 No new announcements at the moment. Stay tuned!</p>
            )}
        </div>
    );
};

export default Announcements;
